<!-- #18 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Update Offline data
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-card class="mt-2">
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >Update

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form>
          <v-card dense flat>
            <v-card-title class="mt-0 pt-0 pl-0 pb-1">
              <span class="body-1 mt-0 pt-0 font-weight-bold"
                >Missing Packages / Orders:
              </span></v-card-title
            >
            <v-card-text class="pb-0">
              <ul class="text-left mb-2">
                <li>
                  Upload the orders that were sent to carriers through an
                  offline process, typically manually uploaded on the Carrier
                  portal.
                </li>
              </ul>
            </v-card-text>
          </v-card>
          <v-card dense flat>
            <v-card-title class="mt-0 pt-0 pl-0 pb-1">
              <span class="body-1 mt-0 pt-0 font-weight-bold"
                >Update Carrier name or Carrier tracking number:
              </span></v-card-title
            >
            <v-card-text class="pb-0">
              <ul class="text-left mb-2">
                <li>
                  Update the Carrier name and tracking number if the system data
                  is not updated.
                </li>
                <li>
                  Note that if the order or package is already delivered, these
                  details won't be updated.
                </li>
              </ul>
            </v-card-text>
          </v-card>
          <v-card dense flat>
            <v-card-title class="mt-0 pt-0 pl-0 pb-1">
              <span class="body-1 mt-0 pt-0 pb-0 font-weight-bold"
                >Update Order value or COD value:
              </span></v-card-title
            >
            <v-card-text class="pb-0">
              <ul class="text-left mb-2">
                <li>
                  If there is any change in the Order value or COD (Cash on
                  Delivery) value after the order was sent to the carrier.
                </li>
                <li>
                  There is a 3-day gap after the order was sent to the carrier
                  during which these changes can be made.
                </li>
                <li>
                  Please note that these changes won't be reflected in the
                  carrier's system.
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>
      <v-divider class="mb-3"></v-divider>
      <v-card-text>
        <v-form ref="form">
          <div class="text-center py-0">
            <v-row no-gutters>
              <v-col
                :md="clientNeeded == 1 ? '4' : '6'"
                v-if="userCategory.user_category === 3"
                class="pb-0"
              >
                <v-autocomplete
                  v-model="selectedType"
                  :items="dataList"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Type"
                  placeholder="Start typing to Search"
                  class="pb-0 pt-0 text-center required"
                  :rules="[(v) => !!v || 'Please select type']"
                  @input="selectClientIs"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col
                class="pl-4 pb-0"
                md="4"
                v-if="userCategory.user_category === 3 && clientNeeded == true"
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  hide-details
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-0 pt-0 text-center required"
                  :rules="[(v) => !!v || 'Please select client']"
                  return-object
                  @focus="fetchClientList"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col :md="clientNeeded == 1 ? '4' : '6'" class="custom">
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  label="Select your packages file"
                  class="required"
                  outlined
                  :rules="[(v) => !!v || 'Please select Packages File']"
                  dense
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-row class="text-left pt-0 pb-0 mt-1">
              <v-col class="pt-0">
                <v-btn
                  color="primary"
                  dark
                  :loading="fileLoader"
                  @click="upload"
                  v-if="
                    checkPermission(
                      'app_consignment_order:package_details_upload'
                    )
                  "
                >
                  Update
                </v-btn>
                <v-btn
                  color="info"
                  class="ml-3"
                  v-if="selectedType"
                  :loading="downloader"
                  @click="downloadTemplate()"
                  >Download template</v-btn
                >

                <v-btn class="ml-3" @click="close()"> Cancel </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
    />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { EventBus } from "@/plugins/event-bus";
import BulkErrors from "@/components/front/common/BulkErrors";

export default {
  components: { BulkErrors },
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchClientList();
    });
  },
  data() {
    return {
      page: "listPage",
      packages: [],
      clients: [],
      dataList: [
        { name: "Missing Packages / Orders", id: "1" },
        {
          name: "Update Carrier name or Carrier tracking number",
          id: "2",
        },
        {
          name: "Update Order value or COD value ",
          id: "3",
        },
      ],
      selectedClient: null,
      total: 0,
      packagesLoader: false,
      search: null,
      options: {},
      searchType: null,
      file: null,
      fileLoader: false,
      dialog: false,
      statusType: null,
      downloader: false,
      uploadRes: {},
      uploadResDialog: false,
      clientLoader: false,
      clientNeeded: false,
      selectedType: "",
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.fetchPackage();
      },
      deep: true,
    },
    search() {
      this.fetchPackage();
    },
    searchType() {
      if (this.search) this.fetchPackage();
    },
  },

  created() {
    EventBus.$off("packageStatus");
    EventBus.$on("packageStatus", (status) => {
      this.statusType = status;
      this.fetchPackage();
    });
  },

  methods: {
    ...mapActions([
      "getAllPackages",
      "downloadPackageDetails",
      "downloadPackageDataTemplateMulti",
      "uploadPackageOldExcel",
      "fetchClient",
      "snackBar",
      "uploadCodValueExcel",
      "uploadClientValueExcel",
      "uploadValueExcel",
    ]),
    selectClientIs() {
      if (this.selectedType == 1) {
        this.clientNeeded = true;
      } else {
        this.clientNeeded = false;
      }
    },
    fetchPackage() {
      this.packages = [];
      this.packagesLoader = true;
      this.getAllPackages({
        ...this.options,
        search: this.search,
        type: this.searchType,
        status: this.statusType,
      })
        .then((res) => {
          this.packagesLoader = false;
          this.packages = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.packagesLoader = false;
        });
    },

    editItem(item) {
      this.$router.push({
        name: "PackageDetails",
        params: {
          id: item.tracking_no,
        },
      });
    },

    close() {
      this.selectedClient = null;
      this.file = null;
      this.$refs.form?.reset();
      this.dialog = false;
    },

    download(id) {
      this.packagesLoader = true;
      this.downloadPackageDetails(id)
        .then((res) => {
          this.fileDownload(res);
          this.packagesLoader = false;
        })
        .catch(() => {
          this.packagesLoader = false;
        });
    },

    downloadTemplate() {
      this.downloader = true;

      var url = "";
      if (this.selectedType == 1) {
        url =
          "api/file_download?file_path=app_packages/orderupdate/past_data_upload_excel_template_missing_package.xlsx";
      } else if (this.selectedType == 2) {
        url =
          "api/file_download?file_path=app_packages/orderupdate/past_data_upload_excel_template_carrier_update.xlsx";
      } else if (this.selectedType == 3) {
        url =
          "api/file_download?file_path=app_packages/orderupdate/past_data_upload_excel_template_cod_order_value.xlsx";
      }
      this.downloadPackageDataTemplateMulti(url)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },

    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file, this.file.name);

      if (this.selectedType == 3) {
        this.uploadCodValueExcel(payload)
          .then((res) => {
            this.fileLoader = false;
            this.dialog = false;
            this.uploadRes = res.data;
            this.uploadResDialog = true;
            // this.snackBar({
            //   color: "success",
            //   message: res.data.message,
            // });
          })
          .catch(() => {
            this.fileLoader = false;
          });
      } else if (this.selectedType == 1) {
        if (this.userCategory.user_category === 3) {
          payload.append("client_id", this.selectedClient.id);
        }
        this.uploadClientValueExcel(payload)
          .then((res) => {
            this.fileLoader = false;
            this.dialog = false;
            this.uploadRes = res.data;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
          })
          .catch(() => {
            this.fileLoader = false;
          });
      } else if (this.selectedType == 2) {
        this.uploadValueExcel(payload)
          .then((res) => {
            this.fileLoader = false;
            this.dialog = false;
            this.uploadRes = res.data;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
          })
          .catch(() => {
            this.fileLoader = false;
          });
      }
    },
    fetchClientList() {
      if (this.clients.length) return;

      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "clickdna",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    fetchTrackingDetails(item) {
      this.$router.push({
        name: "ClientTrackingDetails",
        params: {
          id: item.tracking_no,
          viewName: "orderList",
        },
      });
    },
  },
};
</script>
<style>
.file-padding {
  padding-right: 72px;
}
.custom .v-text-field {
  padding-top: 0;
}
</style>
